import { render, staticRenderFns } from "./ComponentItems.vue?vue&type=template&id=a109759c&scoped=true"
import script from "./ComponentItems.vue?vue&type=script&lang=js"
export * from "./ComponentItems.vue?vue&type=script&lang=js"
import style0 from "./ComponentItems.vue?vue&type=style&index=0&id=a109759c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a109759c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src837179331/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a109759c')) {
      api.createRecord('a109759c', component.options)
    } else {
      api.reload('a109759c', component.options)
    }
    module.hot.accept("./ComponentItems.vue?vue&type=template&id=a109759c&scoped=true", function () {
      api.rerender('a109759c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ComponentItems.vue"
export default component.exports